
import React, { useEffect, useState } from 'react';
import {
    Grid
} from '@mui/material';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import HelpIcon from '@mui/icons-material/Help';
import ReactTooltip from 'react-tooltip';


ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

const classes = {
    lblGraph: {
        backgroundColor: '#F5F5F5',
        color: '#155BCB',
        boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
        borderRadius: 3,
        height: '35px',
        display: 'flex',
        alignItems: 'center',
        padding: 10
    },
    graph: {
        border: '1px solid #D1CCCC',
        boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
        height: '300px'
    },
    gridLabel: {
        display: 'flex',
        width: '100%',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: 5
    },
    helpText: {
        marginTop: -4,
        cursor: 'pointer'
    }
}


export default function OccurrencesByNeighborhood({ occurrences }) {

    const [dataBar, setDataBar] = useState({
        labels: [],
        datasets: [],
    })

    const options = {
        maintainAspectRatio: false,
        responsive: true,
        scales: {
            x: {
                stacked: true,
            },
            y: {
                stacked: true,
            },
        },
    };

    useEffect(() => {
        const data = {}

        for (let i = 0, n = occurrences.length; i < n; i++) {
            const occurrence = occurrences[i];
            const neighborhood = occurrence.neighborhood;

            data[neighborhood] = (data[neighborhood] || 0) + 1;
        }

        setDataBar({
            labels: Object.keys(data),
            datasets: [
                {
                    label: 'Quantidade',
                    data: Object.values(data).sort((a, b) => b - a),
                    backgroundColor: '#a7db64',
                }
            ],
        })

    }, [occurrences]);


    return (
        <div id="ocurrencies-neighboor-dashboard" style={{ width: '100%' }}>
            <Grid item xs={12} sm={12} md={12} lg={12} style={classes.lblGraph}>
                <div style={classes.gridLabel}>
                    <div>
                        Ocorrências por bairro:
                    </div>
                    <div style={classes.helpText}>
                        <ReactTooltip id="proportion-info" className='popup' />
                        <HelpIcon style={{ 'color': '#a1a5ab' }} fontSize="small" data-for="proportion-info" data-place="bottom" data-tip='Relação das ocorrências abertas por bairro.' />
                    </div>
                </div>
            </Grid>

            <Grid item xs={12} sm={12} md={12} lg={12} style={classes.graph}>
                <Bar
                    data={dataBar}
                    options={options}
                />
            </Grid>
        </div>
    )



}